<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="48" width="48" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 48.000002 48.000001">
   <g transform="translate(.0000046973 -1004.4)">
    <g transform="translate(-277.51 605.11)">
     <circle :style="{'fill': circleFill}" cx="301.51" cy="423.25" r="24"/>
    </g>
    <g transform="matrix(.058718 0 0 .058718 9.4379 1013.8)">
     <path style="fill:#00233f" d="m352 92c0 44-36 80-80 80h-48c-44 0-80-36-80-80s36-80 80-80h48c44 0 80 36 80 80z"/>
     <rect style="fill:#f9bda0" height="120" width="128" y="212" x="184"/>
     <polygon style="fill:#e28f71" points="312 212 312 332 248 332 180 212"/>
     <path style="fill:#fcccb9" d="m348.8 125.6c0 80-49.6 152-100.8 152s-100.8-72-100.8-152 49.6-92.8 100.8-92.8 100.8 12.8 100.8 92.8z"/>
     <path style="fill:#f9bda0" d="m248 32.8c51.2 0 100.8 13.6 100.8 92.8 0 80-49.6 152-100.8 152"/>
     <path style="fill:#00233f" d="m280 25.6c0 10.4-8 18.4-18.4 18.4h-27.2c-10.4 0-18.4-8-18.4-18.4v-3.2c0-10.4 8-18.4 18.4-18.4h27.2c10.4 0 18.4 8 18.4 18.4v3.2z"/>
     <polygon style="fill:#0c537a" points="240.8 492 176 292.8 0 358.4 0 492"/>
     <polygon style="fill:#00233f" points="240.8 492 176 292.8 32.8 373.6 0 492"/>
     <polygon style="fill:#d6d6d6" points="135.2 300.8 164 379.2 240 492 240 329.6 176 283.2"/>
     <polygon style="fill:#fff" points="164 379.2 176.8 283.2 240 329.6"/>
     <polygon style="fill:#0c537a" points="255.2 492 320 292.8 496 358.4 496 492"/>
     <polygon style="fill:#00233f" points="255.2 492 320 292.8 463.2 373.6 496 492"/>
     <polygon style="fill:#d6d6d6" points="360.8 300.8 332 379.2 256 492 256 329.6 320 283.2"/>
     <polygon style="fill:#fff" points="332 379.2 319.2 283.2 256 329.6"/>
     <polygon style="fill:#0c537a" points="248 329.6 229.6 340.8 239.2 355.2 224.8 473.6 241.6 492 248 492"/>
     <polygon style="fill:#00233f" points="248 329.6 266.4 340.8 256.8 355.2 271.2 473.6 254.4 492 248 492"/>
    </g>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'User',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/User.vue